import PropTypes from 'prop-types'
import OptionShapePropType from './OptionShapePropType'

const OptionGroupShapePropType = PropTypes.shape({
  label: PropTypes.string,
  defaultIsOpen: PropTypes.bool,
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  tooltip: PropTypes.string,
  options: PropTypes.arrayOf(OptionShapePropType)
})

export default OptionGroupShapePropType
